import axios, { AxiosResponse } from "axios";
import { kore_url } from "./index";
import { memberObject } from "context/initialState/Member";

interface MemberInterface {
  email?: string;
  firstName?: string;
  lastName?: string;
  program?: string;
  phone?: string;
  group?: string;
  site?: string;
  MRN?: string;
}

interface memberResponse {
  items: MemberInterface[];
}

export default {
  login: (username: string, password: string) => {
    const config = {
      auth: {
        username: username,
        password: password
      }
    };
    axios(config).then((creds) => {});
  },
  getAll: async (token: string, scope?: string) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return await axios
      .get(
        kore_url +
          `/api/v4/members?${scope}select=id,email,username,phone,createdAt,updatedAt,firstName,lastName,groups,site,externId,program,birthDate,hubIds,latestReading,status,locked,enrollment,acknowledged`,
        config
      )
      .then((memberList) => {
        return memberList.data;
      })
      .catch((err) => {
        // Re-throw so callers' .catch blocks fire and failed loads propagate
        // (matches coordinator.getFullCoordList). Returning `err` here resolved
        // the promise with an AxiosError, so consumers received an error object
        // in place of `{ items }` -> empty/undefined member lists and no retry.
        throw err;
      });
  },
  getOne: async (memberId: string, token: string) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*"
      }
    };
    const selectFields =
      "id,firstName,lastName,email,externId,username,program,phone,groups,site,birthDate,gender,language,condition,height,weight,status,units,locked,estimatedGraduation,acknowledged";
    return await axios
      .get(
        kore_url + "/api/v2/members/" + memberId + "?select=" + selectFields,
        config
      )
      .then((memberList) => {
        return memberList.data;
      });
  },
  upsert: (action: string, body: object, token: string, memberID?: string) => {
    const config = {
      method: action === "create" ? "POST" : "PUT",
      headers: { Authorization: `Bearer ${token}` },
      url: `${kore_url}/api/v2/members${
        action === "create" ? "" : `/${memberID}`
      }`,
      data: body
    };
    return axios(config)
      .then((newMember: AxiosResponse) => {
        return newMember.data;
      })
      .catch((err: any) => {
        //Do not remove, for error logging active issue with WPH
        // console.log(err);
        throw err
      });
  },
  patch: (memberId: string, body: Partial<memberObject>, token: string) => {
    return axios({
      method: "PATCH",
      url: `${kore_url}/api/v2/members/${memberId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: body
    })
      .then((res: AxiosResponse) => res.data)
      .catch((err: any) => {
        throw err;
      });
  },
  getAssociations: (memberId: string, token: string) => {
    const config = {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      url: `${kore_url}/api/v2/members/${memberId}/coordinators`
    };
    return axios(config).then((coordList: AxiosResponse) => {
      return coordList.data;
    });
  },
  updateAssociations: (
    memberId: string,
    coordinatorList: string[],
    token: string
  ) => {
    const config = {
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      url: `${kore_url}/api/v2/members/${memberId}/coordinators`,
      data: coordinatorList
    };
    return axios(config).then((coordList: AxiosResponse) => {
      return coordList.data;
    });
  },
  addSingleAssociations: (
    memberId: string,
    coordId: string,
    token: string
  ) => {
    return axios({
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      url: `${kore_url}/api/v4/members/${memberId}/coordinators`,
      data: { coordinatorId: coordId }
    });
  },
  removeSingleAssociations: (
    memberList: string[],
    coordId: string,
    token: string
  ) => {
    memberList.map((memberId) => {
      const config = {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
        url: `${kore_url}/api/v2/members/${memberId}/coordinators`,
        data: { coordinatorId: coordId }
      };
      axios(config).then((coordList: AxiosResponse) => {
      });
    });
    return "done";
  },
  remove: (userId: string, token: string) => {
    const config = {
      method: "DELETE",
      url: `${kore_url}/api/v2/members/${userId}`,
      headers: { Authorization: `Bearer ${token}` }
    };
    return axios(config).then((newCoordinator: AxiosResponse) => {
      return newCoordinator.data;
    });
  }
};
